import { Card } from "antd";

const colors = {
    primary: '#1890ff',
    secondary: '#242166',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#ff4d4f',
    info: '#13c2c2',
    lightBg: '#f5f7fa',
    cardBg: '#ffffff',
    textPrimary: '#262626',
    textSecondary: '#8c8c8c',
    border: '#e8e8e8',
    gradient: 'linear-gradient(135deg, #1890ff 0%, #242166 100%)',
};

export const StatCard = ({ title, value, subtitle, icon, iconBg, gradient, onClick, active }) => (
    <Card
        bordered={false}
        style={{
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            transition: 'all 0.3s ease',
            cursor: onClick ? 'pointer' : 'default',
            overflow: 'hidden',
            position: 'relative',
            border: active ? `1px solid ${colors.primary}` : undefined
        }}
        bodyStyle={{ padding: '24px' }}
        hoverable
        onClick={onClick}
    >
        <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '100px',
            height: '100px',
            background: gradient,
            opacity: 0.1,
            borderRadius: '0 0 0 100%'
        }} />
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', position: 'relative' }}>
            <div>
                <div style={{ color: colors.textSecondary, fontSize: '14px', marginBottom: '8px' }}>
                    {title}
                </div>
                <div style={{ fontSize: '32px', fontWeight: '700', color: colors.textPrimary, marginBottom: '4px' }}>
                    {value}
                </div>
                <div style={{ color: colors.textSecondary, fontSize: '12px' }}>
                    {subtitle}
                </div>
            </div>
            <div style={{
                width: '56px',
                height: '56px',
                borderRadius: '12px',
                background: iconBg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px'
            }}>
                <i className={icon} style={{ color: '#fff' }} />
            </div>
        </div>
    </Card>
);
